export type NamedColor = { hex: string; name: string };

/** Palette sorties (excursions). La première = défaut. Bleus, violets, verts, oranges et rouges moyennement clairs (lisibles sur UI sombre). */
export const COLOR_PALETTE_EXCURSION: NamedColor[] = [
  { hex: "#7986cb", name: "Indigo clair" },
  { hex: "#64b5f6", name: "Bleu ciel" },
  { hex: "#4fc3f7", name: "Cyan" },
  { hex: "#9575cd", name: "Violet" },
  { hex: "#ba68c8", name: "Mauve" },
  { hex: "#9fa8da", name: "Lavande" },
  { hex: "#81c784", name: "Vert menthe" },
  { hex: "#66bb6a", name: "Vert" },
  { hex: "#aed581", name: "Vert lime" },
  { hex: "#ffb74d", name: "Orange clair" },
  { hex: "#ffa726", name: "Orange" },
  { hex: "#ffcc80", name: "Pêche" },
  { hex: "#e57373", name: "Rouge clair" },
  { hex: "#ef5350", name: "Rouge" },
];

/** Palette groupes (dans une sortie). La première = défaut. */
export const COLOR_PALETTE_GROUP: NamedColor[] = [
  { hex: "#000000", name: "Noir" },
  { hex: "#FFD700", name: "Or" },
  { hex: "#FF9800", name: "Orange" },
  { hex: "#F44336", name: "Rouge" },
  { hex: "#4CAF50", name: "Vert" },
  { hex: "#2196F3", name: "Bleu" },
  { hex: "#9C27B0", name: "Violet" },
  { hex: "#E91E63", name: "Rose" },
  { hex: "#03A9F4", name: "Bleu clair" },
  { hex: "#9E9E9E", name: "Gris" },
  { hex: "#616161", name: "Gris foncé" },
];

/** Palette QR codes (équipements). */
export const COLOR_PALETTE_QR: NamedColor[] = [
  { hex: "#B39DDB", name: "Violet clair" },
  { hex: "#64B5F6", name: "Bleu clair" },
  { hex: "#FFFFFF", name: "Blanc" },
  { hex: "#81C784", name: "Vert clair" },
  { hex: "#FFF176", name: "Jaune" },
  { hex: "#E57373", name: "Rouge clair" },
  { hex: "#F06292", name: "Rose" },
  { hex: "#FFB74D", name: "Orange clair" },
];

/** Palette congés (HR). */
export const COLOR_PALETTE_LEAVE: NamedColor[] = [
  { hex: "#F44336", name: "Rouge" },
  { hex: "#E91E63", name: "Rose" },
  { hex: "#9C27B0", name: "Violet" },
  { hex: "#673AB7", name: "Indigo" },
  { hex: "#009688", name: "Turquoise" },
  { hex: "#4CAF50", name: "Vert" },
  { hex: "#FF9800", name: "Orange" },
  { hex: "#FFC107", name: "Jaune" },
  { hex: "#795548", name: "Marron" },
  { hex: "#607D8B", name: "Bleu-gris" },
];

export const EXCURSION_DEFAULT_COLOR = COLOR_PALETTE_EXCURSION[0].hex;
export const GROUP_DEFAULT_COLOR = "#000000";

/** Fallback background for excursion cards (slot, month, agenda). */
export const EXCURSION_CARD_FALLBACK_COLOR = "#3A5A3A";

export const findColorName = (
  hex: string,
  inSet: NamedColor[] = [...COLOR_PALETTE_QR, ...COLOR_PALETTE_LEAVE],
): string | undefined => {
  const norm = (hex || "").toUpperCase();
  return inSet.find((c) => c.hex.toUpperCase() === norm)?.name;
};
